











































import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { BaseInputBox } from '../base-input-box';
import { BaseButtonIcon } from '../base-button-icon';
import { BaseIcon } from '../base-icon';

@Component({
  name: 'BaseNumericalStepper',
  inheritAttrs: false,
  components: {
    BaseInputBox,
    BaseButtonIcon,
    BaseIcon,
  },
})
export default class BaseNumericalStepper extends Vue {
  @Prop() id: string;
  @Prop({ default: 'value-that-chrome-doesnt-recognize' }) autocomplete: string;
  @Prop({ default: '' }) value: string | number;
  @Prop({ default: false }) success: boolean;
  @Prop({ default: '' }) helpMessage: string;
  @Prop({ default: '' }) errorMessage: string;
  @Prop({ default: false }) error: boolean;
  @Prop() disabled: boolean;
  @Prop() delayedFocus: boolean;
  @Prop() max: string | number;
  @Prop({ default: 0 }) min: string | number;
  @Ref('input') inputElement: HTMLInputElement;

  focused = false;
  lazyValue: string | number = '';
  autoFilled = false;

  @Watch('value')
  watchValue(newValue: string | number) {
    this.lazyValue = newValue;
  }

  get inputId(): string {
    return this.id || `input-${this['_uid']}`;
  }

  get listeners(): Record<string, (arg?) => any | ((arg?) => any)[]> {
    return {
      ...this.$listeners,
      input: this.handleInput,
      focus: this.handleFocus,
      blur: this.handleBlur,
      animationstart: this.checkAnimation,
    };
  }

  get active(): boolean {
    return this.focused || !!this.lazyValue || this.autoFilled || this.numberIsZero;
  }

  get numberIsZero(): boolean {
    return this.lazyValue === 0;
  }

  handleFocus() {
    this.focused = true;
    this.$emit('focus');
  }

  handleBlur(event: Event) {
    this.focused = false;
    this.$emit('blur', event);
  }

  handleInput(event: Event) {
    this.autoFilled = false;
    if (this.disabled) return;
    const { value } = event.target as HTMLTextAreaElement;
    this.lazyValue = value;
    this.$emit('input', value);
  }

  handleIncrement() {
    if ((this.max && Number(this.lazyValue) >= Number(this.max)) || this.disabled) {
      return;
    }
    this.lazyValue = this.lazyValue ? Number(this.lazyValue) + 1 : 1;
    this.handleUpdate();
  }

  handleDecrement() {
    if (Number(this.lazyValue) <= Number(this.min) || this.disabled) {
      return;
    }
    this.lazyValue = this.lazyValue ? Number(this.lazyValue) - 1 : 0;
    this.handleUpdate();
  }

  handleUpdate() {
    this.$emit('input', this.lazyValue);
    this.$emit('blur', { target: { value: this.lazyValue } });
  }

  checkAnimation(event: AnimationEvent) {
    if (event.animationName.includes('onAutoFillStart')) {
      this.autoFilled = true;
    }
  }

  focus() {
    this.inputElement.focus();
  }
  blur() {
    this.inputElement.blur();
  }

  async mounted() {
    this.lazyValue = this.value;
    if (this.delayedFocus) {
      setTimeout(() => {
        this.inputElement.focus();
      }, 1500);
    }
  }
}
